//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  is: "آيسلندا",
  et: "إثيوبيا",
  az: "أذربيجان",
  am: "أرمينيا",
  aw: "أروبا",
  er: "إريتريا",
  es: "إسبانيا",
  au: "أستراليا",
  ee: "إستونيا",
  il: "إسرائيل",
  sz: "إسواتيني",
  af: "أفغانستان",
  ps: "الأراضي الفلسطينية",
  ar: "الأرجنتين",
  jo: "الأردن",
  tf: "الأقاليم الجنوبية الفرنسية",
  io: "الإقليم البريطاني في المحيط الهندي",
  ec: "الإكوادور",
  ae: "الإمارات العربية المتحدة",
  al: "ألبانيا",
  bh: "البحرين",
  br: "البرازيل",
  pt: "البرتغال",
  ba: "البوسنة والهرسك",
  cz: "التشيك",
  me: "الجبل الأسود",
  dz: "الجزائر",
  dk: "الدانمرك",
  cv: "الرأس الأخضر",
  sv: "السلفادور",
  sn: "السنغال",
  sd: "السودان",
  se: "السويد",
  eh: "الصحراء الغربية",
  so: "الصومال",
  cn: "الصين",
  iq: "العراق",
  ga: "الغابون",
  va: "الفاتيكان",
  ph: "الفلبين",
  cm: "الكاميرون",
  cg: "الكونغو - برازافيل",
  cd: "الكونغو - كينشاسا",
  kw: "الكويت",
  de: "ألمانيا",
  ma: "المغرب",
  mx: "المكسيك",
  sa: "المملكة العربية السعودية",
  gb: "المملكة المتحدة",
  no: "النرويج",
  at: "النمسا",
  ne: "النيجر",
  in: "الهند",
  us: "الولايات المتحدة",
  jp: "اليابان",
  ye: "اليمن",
  gr: "اليونان",
  aq: "أنتاركتيكا",
  ag: "أنتيغوا وبربودا",
  ad: "أندورا",
  id: "إندونيسيا",
  ao: "أنغولا",
  ai: "أنغويلا",
  uy: "أورغواي",
  uz: "أوزبكستان",
  ug: "أوغندا",
  ua: "أوكرانيا",
  ir: "إيران",
  ie: "أيرلندا",
  it: "إيطاليا",
  pg: "بابوا غينيا الجديدة",
  py: "باراغواي",
  pk: "باكستان",
  pw: "بالاو",
  bb: "بربادوس",
  bm: "برمودا",
  bn: "بروناي",
  be: "بلجيكا",
  bg: "بلغاريا",
  bz: "بليز",
  bd: "بنغلاديش",
  pa: "بنما",
  bj: "بنين",
  bt: "بوتان",
  bw: "بوتسوانا",
  pr: "بورتوريكو",
  bf: "بوركينا فاسو",
  bi: "بوروندي",
  pl: "بولندا",
  bo: "بوليفيا",
  pf: "بولينيزيا الفرنسية",
  pe: "بيرو",
  by: "بيلاروس",
  th: "تايلاند",
  tw: "تايوان",
  tm: "تركمانستان",
  tr: "تركيا",
  tt: "ترينيداد وتوباغو",
  td: "تشاد",
  cl: "تشيلي",
  tz: "تنزانيا",
  tg: "توغو",
  tv: "توفالو",
  tk: "توكيلو",
  tn: "تونس",
  to: "تونغا",
  tl: "تيمور - ليشتي",
  jm: "جامايكا",
  gi: "جبل طارق",
  ax: "جزر آلاند",
  bs: "جزر البهاما",
  km: "جزر القمر",
  mq: "جزر المارتينيك",
  mv: "جزر المالديف",
  um: "جزر الولايات المتحدة النائية",
  pn: "جزر بيتكيرن",
  tc: "جزر توركس وكايكوس",
  sb: "جزر سليمان",
  fo: "جزر فارو",
  fk: "جزر فوكلاند",
  vg: "جزر فيرجن البريطانية",
  vi: "جزر فيرجن التابعة للولايات المتحدة",
  ky: "جزر كايمان",
  ck: "جزر كوك",
  cc: "جزر كوكوس (كيلينغ)",
  mh: "جزر مارشال",
  mp: "جزر ماريانا الشمالية",
  wf: "جزر والس وفوتونا",
  bv: "جزيرة بوفيه",
  cx: "جزيرة كريسماس",
  im: "جزيرة مان",
  nf: "جزيرة نورفولك",
  hm: "جزيرة هيرد وجزر ماكدونالد",
  cf: "جمهورية أفريقيا الوسطى",
  do: "جمهورية الدومينيكان",
  za: "جنوب أفريقيا",
  ss: "جنوب السودان",
  ge: "جورجيا",
  gs: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  dj: "جيبوتي",
  je: "جيرسي",
  dm: "دومينيكا",
  rw: "رواندا",
  ru: "روسيا",
  ro: "رومانيا",
  re: "روينيون",
  zm: "زامبيا",
  zw: "زيمبابوي",
  ci: "ساحل العاج",
  ws: "ساموا",
  as: "ساموا الأمريكية",
  bl: "سان بارتليمي",
  pm: "سان بيير ومكويلون",
  mf: "سان مارتن",
  sm: "سان مارينو",
  vc: "سانت فنسنت وجزر غرينادين",
  kn: "سانت كيتس ونيفيس",
  lc: "سانت لوسيا",
  sx: "سانت مارتن",
  sh: "سانت هيلينا",
  st: "ساو تومي وبرينسيبي",
  lk: "سريلانكا",
  sj: "سفالبارد وجان ماين",
  sk: "سلوفاكيا",
  si: "سلوفينيا",
  sg: "سنغافورة",
  sy: "سوريا",
  sr: "سورينام",
  ch: "سويسرا",
  sl: "سيراليون",
  sc: "سيشل",
  rs: "صربيا",
  tj: "طاجيكستان",
  om: "عُمان",
  gm: "غامبيا",
  gh: "غانا",
  gd: "غرينادا",
  gl: "غرينلاند",
  gt: "غواتيمالا",
  gp: "غوادلوب",
  gu: "غوام",
  gf: "غويانا الفرنسية",
  gy: "غيانا",
  gg: "غيرنزي",
  gn: "غينيا",
  gq: "غينيا الاستوائية",
  gw: "غينيا بيساو",
  vu: "فانواتو",
  fr: "فرنسا",
  ve: "فنزويلا",
  fi: "فنلندا",
  vn: "فيتنام",
  fj: "فيجي",
  cy: "قبرص",
  qa: "قطر",
  kg: "قيرغيزستان",
  kz: "كازاخستان",
  nc: "كاليدونيا الجديدة",
  hr: "كرواتيا",
  kh: "كمبوديا",
  ca: "كندا",
  cu: "كوبا",
  cw: "كوراساو",
  kr: "كوريا الجنوبية",
  kp: "كوريا الشمالية",
  cr: "كوستاريكا",
  co: "كولومبيا",
  ki: "كيريباتي",
  ke: "كينيا",
  lv: "لاتفيا",
  la: "لاوس",
  lb: "لبنان",
  lu: "لوكسمبورغ",
  ly: "ليبيا",
  lr: "ليبيريا",
  lt: "ليتوانيا",
  li: "ليختنشتاين",
  ls: "ليسوتو",
  mt: "مالطا",
  ml: "مالي",
  my: "ماليزيا",
  yt: "مايوت",
  mg: "مدغشقر",
  eg: "مصر",
  mk: "مقدونيا الشمالية",
  mw: "ملاوي",
  mo: "منطقة ماكاو الإدارية الخاصة",
  mn: "منغوليا",
  mr: "موريتانيا",
  mu: "موريشيوس",
  mz: "موزمبيق",
  md: "مولدوفا",
  mc: "موناكو",
  ms: "مونتسرات",
  mm: "ميانمار (بورما)",
  fm: "ميكرونيزيا",
  na: "ناميبيا",
  nr: "ناورو",
  np: "نيبال",
  ng: "نيجيريا",
  ni: "نيكاراغوا",
  nz: "نيوزيلندا",
  nu: "نيوي",
  ht: "هايتي",
  hn: "هندوراس",
  hu: "هنغاريا",
  nl: "هولندا",
  bq: "هولندا الكاريبية",
  hk: "هونغ كونغ الصينية (منطقة إدارية خاصة)",
};
